import { supabase } from '../../supabaseClient';

/* Accès aux données « affaire_activites ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function fetchDealActivitiesByNature() {
  return supabase
    .from('affaire_activites')
    .select('id,affaire_id,type,date,note')
    .eq('nature', 'action')
    .eq('etat', 'prevu');
}

export function fetchDealActivities(dealId) {
  return supabase.from('affaire_activites').select('*').eq('affaire_id', dealId);
}

export function reopenDealActivity(act, loadDealActivities, loadDeals) {
  return supabase
    .from('affaire_activites')
    .update({ etat: 'prevu', completed_at: null, completed_by_id: null, note_completion: null })
    .eq('id', act.id)
    .then(() => {
      if (act.affaire_id) loadDealActivities(act.affaire_id);
      loadDeals();
    });
}

export function completeDealActivity(act, noteCompletion, session) {
  return supabase
    .from('affaire_activites')
    .update({
      etat: 'fait',
      completed_at: new Date().toISOString(),
      completed_by_id: session.user.id,
      note_completion: noteCompletion || null,
    })
    .eq('id', act.id);
}

export function deleteDealActivity(act) {
  return supabase.from('affaire_activites').delete().eq('id', act.id);
}

export function updateDealActivity(e) {
  return supabase
    .from('affaire_activites')
    .update({
      type: e.type,
      date: e.date || null,
      etat: e.etat,
      note: e.note || null,
    })
    .eq('id', e.id);
}
